"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createDataQualityCellFormatter = void 0;
var data_catalog_shared_1 = require("@tableau/data-catalog-shared");
var react_1 = __importDefault(require("react"));
var IconStyle = {
    position: 'relative',
    left: '13.4px',
    top: '2px'
};
/** @deprecated TFS1478812 */
function createDataQualityCellFormatter(_a) {
    var subjectArea = _a.subjectArea, getWarningsFromRowData = _a.getWarningsFromRowData, linksDisabled = _a.linksDisabled;
    return function (props) {
        var _a;
        var upstreamWarnings = (_a = getWarningsFromRowData(props.row.data)) !== null && _a !== void 0 ? _a : [];
        return react_1.default.createElement(data_catalog_shared_1.SiteUrlsContext.Consumer, null, function (urls) { return (react_1.default.createElement("div", { style: IconStyle },
            react_1.default.createElement(data_catalog_shared_1.WarningStatusIcon, { iconOnly: true, kind: 'graph', upstreamWarnings: upstreamWarnings, subjectArea: subjectArea, anchoredAsset: null, anchoredWarnings: [], urls: linksDisabled ? undefined : urls, linksDisabled: linksDisabled }))); });
    };
}
exports.createDataQualityCellFormatter = createDataQualityCellFormatter;
//# sourceMappingURL=createDataQualityCellFormatter.js.map